import React, { Component } from 'react';
import { Form, FormGroup, Input, Label, Button, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { func, array } from 'prop-types';
import EditNotificationsFormField from './EditNotificationsFormField';
import EditNotificationsSMS from './EditNotificationsSMS';
import { isNil } from '../../utils/utils';
import EditNotificationsPhoneDisclaimer from './EditNotificationsPhoneDisclaimer';

//убрать в конфиг
const defaultNotificationsTime = '21:00';

class EditNotificationsForm extends Component {
  static propTypes = {
    notifications: array.isRequired,
    submit: func.isRequired,
    change: func.isRequired,
  };
  static defaultProps = {
    notifications: [],
    submit() {},
    change() {},
  };

  checkTimeString = (e) => {
    const { target } = e;
    const isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(target.value);

    if (!isValid) {
      target.value = defaultNotificationsTime;
    }
  };

  renderTitles = (notifications = []) => {
    const result = [];

    if (!notifications.length) return;

    Object.keys(notifications[0].transport).forEach((title) => {
      const classes = title === 'sms' ? 'text-uppercase' : 'text-capitalize';

      result.push(
        <Col key={title} md={{ size: 2 }} className="text-center">
          <strong className={classes}>{title}</strong>
        </Col>,
      );
    });

    return result;
  };

  renderAdditionalParams = (params, index) => {
    const { notifications, change } = this.props;

    return Object.keys(params).map((field) => (
      <Col
        lg={{ size: 6 }}
        key={`notifications_params_${field}`}
        className="additional-field-container"
      >
        <div className="additional-field-inner form-group-upper-label">
          <Label className="additionalField_title">{params[field].title}</Label>
          <Input
            type={'time'}
            name={`${index}_params_${field}`}
            value={notifications[index].params[field].value}
            onChange={change}
            onBlur={this.checkTimeString}
            className="form-control_inline"
          />
        </div>
      </Col>
    ));
  };

  render() {
    const {
      notifications,
      submit,
      change,
      openAlert,
      profile: { phone_approved, sms_payout },
    } = this.props;

    return (
      <Form onSubmit={submit} method="POST" autoComplete="off" className="edit-notifications-form">
        <div className="edit-notifications-form-wrapper">
          <div className="edit-notifications-form-header form-group row">
            <Col md={{ size: 6 }}>
              <FormattedMessage id="profile.email" defaultMessage="E-mail" />
              {/* <FormattedMessage
                id="notifications.type-title"
                defaultMessage="Type of notification"
              /> */}
            </Col>
            {/* {this.renderTitles(notifications)} */}

            {/* <Col md={{ size: 2 }} className="text-center">
            <strong>Telegram</strong>
          </Col> */}

            {/* <Col md={{ size: 2 }} className="text-center">
            <strong>E-mail</strong>
          </Col>

          <Col md={{ size: 2 }} className="text-center">
            <strong>SMS</strong>
          </Col> */}
          </div>

          {notifications.map((notification, fieldIndex) => (
            <>
              <FormGroup row key={notification.title}>
                <Col className="edit-notifications-form-title edit-notifications-form-title-2">
                  <div className="row align-items-center">
                    <Col
                      lg={{
                        size:
                          notification.id === 9
                            ? 12
                            : !isNil(notification.params) && notification.id !== 8
                            ? 6
                            : 12,
                      }}
                    >
                      {notification.title}
                    </Col>

                    {notification.params &&
                      !isNil(notification.params) &&
                      notification.id !== 8 &&
                      this.renderAdditionalParams(notification.params, fieldIndex)}
                  </div>
                </Col>

                {Object.keys(notification.transport).map((field, index) => (
                  <Col md={{ size: 2 }} key={`${notification.title}_${field}`}>
                    <FormGroup check className="text-md-center">
                      {/* <Label
                      for={`${notification.id}_${field}`}
                      className="notification-checkbox-label"
                    >
                      {field}
                    </Label> */}

                      <EditNotificationsFormField
                        key={`${notification.title}_${field}_checkbox`}
                        onChange={change}
                        field={notification.transport[field]}
                        fieldName={field}
                        id={notification.id}
                        index={fieldIndex}
                        notifications={notifications}
                      />
                    </FormGroup>
                  </Col>
                ))}
              </FormGroup>
            </>
          ))}
          {sms_payout && <EditNotificationsSMS theme={this.props.theme} openAlert={openAlert} />}
        </div>
        <div className="edit-notifications-form-button-wrapper">
          <Button color="primary" size="md">
            <FormattedMessage id="profile.save" defaultMessage="Type of notification" />
          </Button>
        </div>
      </Form>
    );
  }
}

export default EditNotificationsForm;
